@layer globalSearch.shadow {

:host {

  --global-search-background-color: var(--white-5);
  --global-search-border-radius: var(--circular-radius);
  --global-search-transition: background var(--duration) var(--easing);
  --global-search-hover-background-color: var(--white-10);
  --global-search-input-border: var(--white-border);

  --global-search-icon-width: 2rem;
  --global-search-icon-color: inherit;

  --global-search-input-width: 100px;
  --global-search-input-font-size: 12px;
  --global-search-input-font: var(--page-font);
  --global-search-input-color: var(--text-color);

  --global-search-placeholder-color: var(--white-10);

  --global-search-label-font-size: 11px;
  --global-search-label-padding: 2px 3px;
  --global-search-label-color: var(--white-20);
  --global-search-label-border: var(--white-border);
  --global-search-label-border-radius: var(--border-radius);

  --global-search-input-padding: 8px 10px;


  --global-search-modal-background: var(--page-background);

  --global-search-modal-input-font-size: 18px;

  --input-text-color: rgba(255, 255, 255, 0.6);
  --input-focused-color: rgba(255, 255, 255, 1);
  --input-border: 1px solid oklch(.96 .01 279.32 / 15%);
}

* {
  box-sizing: border-box;
}
input {
  outline: none;
  border: none;
}

.inline-search {
  cursor: text;
  display: flex;
  justify-content: stretch;

  &::part(input) {
    border: var(--global-search-input-border);
    background-color: var(--global-search-background-color);
    border-radius: var(--global-search-border-radius);
    transition: var(--global-search-transition);
  }
  &::part(input-field) {
    padding: var(--global-search-input-padding);
  }
  &:hover {
    &::part(input) {
      background-color: var(--global-search-hover-background-color);
    }
  }


  .label {
    display: inline-block;
    text-wrap: nowrap;
    margin-left: auto;
    padding: var(--global-search-label-padding);
    line-height: 1;
    color: var(--global-search-label-color);
    font-size: var(--global-search-label-font-size);
    font-weight: bold;
    border: var(--global-search-label-border);
    border-radius: var(--global-search-label-border-radius);
  }
  input {
    width: var(--global-search-input-width);
    border: none;
    font-size: var(--global-search-input-font-size);
    font-family: var(--global-search-input-font);
    color: var(--global-search-input-color);
    background-color: transparent;
    flex-grow: 1;
  }
  input::placeholder {
    color: var(--global-search-placeholder-color);
  }
  input:focus {
    outline: none;
  }
}


ui-modal {

  width: 700px;

  &::part(dialog) {
    margin-top: 0rem;
  }

  &::part(modal) {
    background-color: var(--global-search-modal-background);
    padding: 0rem;
  }

  .search {
    background-color: transparent;
    padding: 2rem 1.5rem;
    border-radius: var(--top-attached-border-radius);
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.4);
    background-image: linear-gradient(to bottom right, rgb(255 255 255 / 2%), rgb(0 0 0 / 33%));


    .input {
      font-size: var(--global-search-modal-input-font-size);

      &::part(input) {
        background-color: var(--white-10);
        border-radius: var(--circular-radius);
      }
    }
  }
  .results {
    display: flex;
    flex-direction: column;
    gap: var(--spacing);
    background-color: var(--standard-0);
    background-image: linear-gradient(to bottom right, rgb(23 27 30), rgb(2 14 22));
    border-radius: var(--bottom-attached-border-radius);
    min-height: 500px;
    padding: 1rem;
    color: #FFFFFF;
    max-height: calc(100vh - 200px);
    overflow: auto;

    .result {
      display: block;
      text-decoration: none;
      color: var(--white-text-color);
      background-color: rgb(0 0 0 / 28%);
      padding: var(--padding);
      border-radius: var(--border-radius);
      box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.3);
      border: 1px solid rgb(165 165 165 / 10%);

      &.active {
        border-color: var(--primary-text-color);
        background-color: oklch(0.29 0.03 233.5);
      }
      &:hover {
        border: 1px solid rgb(165 165 165 / 60%);
      }

    }
    .result h3 {
      margin: 0rem;
      font-size: 16px;

      .subtitle {
        font-size: 11px;
        margin-left: 0px;
        font-weight: normal;
        font-style: italic;
        color: rgb(255 255 255 / 72%);
        span {
          color: rgb(255 255 255 / 16%);
        }
      }

      .tags {
        float: right;
        display: inline-block;
        margin-left: 5px;
      }
      .tag {
        font-size: 11px;
        padding: 3px 5px;
        background-color: rgb(24 24 24);
        color: rgb(255 255 255 / 44%);
        border-radius: 5px;
        vertical-align: middle;
        font-weight: normal;
        margin: 0px 0px 0px 6px;
      }
      .red.tag {
        background-color: rgb(31 11 37);
        color: #ff6de7;
      }
      .purple.tag {
        background-color: rgb(31 11 37);
        color: #ff6de7;
      }
      .orange.tag {
        background-color: rgb(35 29 14);
        color: #dabf00;
      }
      .blue.tag {
        background-color: rgb(14 30 35);
        color: #009fda;
      }
    }

    .description {
      font-weight: normal;
      font-size: 14px;
      margin: 1px 0px 0px 0px;
      color: var(--white-30);
    }

    .subresults {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 3px 9px;
      background-color: rgba(255, 255, 255, 0.03);
      border-radius: 5px;
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2) inset;
      margin-top: 8px;
      a.sub {
        flex-basis: 33.333%;
        font-size: 11px;
        color: var(--white-30);
        text-decoration: none;
        font-weight: normal;
      }
      a.sub:hover {
        color: var(--link-hover-color);
      }
    }

    .result h3 + p {
      margin: 5px 0rem 0rem;
    }
    .result:first-child {
      margin-top: 0rem;
    }
    .result:last-child {
      margin-bottom: 0rem;
    }
    .excerpt {
      color: var(--standard-20);
    }
    mark {
      background-color: #009fda;
      color: #FFFFFF;
    }
  }

  .placeholder {
    min-height: 350px;
    display: flex;
    align-items: center;
    font-size: 16px;
    justify-content: center;
    flex-direction: column;

    ui-icon {
      display: block;
      opacity: 0.5;
      font-size: 48px;
      margin-bottom: 1rem;
    }
    p {
      margin: 0rem;
      b {
        color: var(--primary-text-color);
      }
    }
  }
}


::-webkit-scrollbar {
  -webkit-appearance: none;
  width: var(--scrollbar-width);
  height: var(--scrollbar-height);
}

/* Scrollbars */
::-webkit-scrollbar-track {
  background: var(--track-background);
  border-radius: var(--track-border-radius);
}
::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: var(--thumb-border-radius);
  background: var(--thumb-background);
  transition: var(--thumb-transition);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: var(--thumb-inactive-background);
}
::-webkit-scrollbar-thumb:hover {
  background: var(--thumb-hover-background);
}

}
